// Enhanced variant selection initialization
document.addEventListener('DOMContentLoaded', function() {
  // Function to initialize variant selections
  function initializeVariantSelections() {
    const productVariantsElements = document.querySelectorAll('product-variants');
    
    productVariantsElements.forEach(function(productVariants) {
      const formId = productVariants.getAttribute('form-id');
      const form = document.getElementById(formId);
      
      if (!form) return;
      
      // Initialize all option groups
      const optionGroups = productVariants.querySelectorAll('[data-selector-type]');
      
      optionGroups.forEach(function(optionGroup, index) {
        const optionName = `option${index + 1}`;
        
        // Check if any option is already selected
        const checkedInput = optionGroup.querySelector(`input[name="${optionName}"]:checked`);
        
        if (!checkedInput) {
          // Select first available option
          const firstInput = optionGroup.querySelector(`input[name="${optionName}"]`);
          if (firstInput) {
            firstInput.checked = true;
            
            // Update display value
            const valueElement = document.querySelector(`#${firstInput.getAttribute('data-bind-value')}`);
            if (valueElement) {
              valueElement.textContent = firstInput.value;
            }
            
            // Trigger change event to update other dependencies
            firstInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          // If already selected, make sure the display value is correct
          const valueElement = document.querySelector(`#${checkedInput.getAttribute('data-bind-value')}`);
          if (valueElement && valueElement.textContent !== checkedInput.value) {
            valueElement.textContent = checkedInput.value;
          }
        }
      });
    });
  }
  
  // Initialize on page load with a small delay to ensure DOM is fully ready
  setTimeout(initializeVariantSelections, 100);
  
  // Re-initialize when product variants are loaded
  document.addEventListener('product:loaded', initializeVariantSelections);
});

// Additional enhancement to ensure price updates correctly
document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  if (!variant) return;
  
  // Update any additional price displays that might not be caught by the main system
  const priceElements = document.querySelectorAll('[data-product-price]');
  priceElements.forEach(function(element) {
    if (element.getAttribute('data-product-price') !== element.closest('[data-product-price-list]')?.getAttribute('data-product-price')) {
      const formattedPrice = Shopify.formatMoney(variant.price, window.themeVariables.settings.moneyFormat);
      element.innerHTML = formattedPrice;
    }
  });
  
  // Ensure add to cart button is properly enabled/disabled
  const addToCartButtons = document.querySelectorAll('button[name="add"], input[name="add"]');
  addToCartButtons.forEach(function(button) {
    button.disabled = !variant.available;
    if (variant.available) {
      button.textContent = button.getAttribute('data-add-to-cart-text') || 'Add to cart';
    } else {
      button.textContent = button.getAttribute('data-sold-out-text') || 'Sold out';
    }
  });
});